export default __webpack_public_path__ + "static/media/misc-books3-1440w.2650329e.webp";